export default [
    {
        id: 'specialists',
        to: '/specialists',
        name: 'Специалисты'
    },
    {
        id: 'shop',
        to: '/goods',
        name: 'Магазин',
    },
    {
        id: 'payment',
        to: '/foreign-payments',
        name: 'Оплата',
        items: {
            'payment-russian': {
                to: 'https://otvet.co/payment_rules',
                name: 'Российские карты'
            },
            'payment-foreign': {
                to: '/foreign-payments',
                name: 'Иностранные карты'
            }
        }
    },
    {
        id: 'faq',
        to: '/faq',
        name: 'Вопрос — ответ'
    },
    {
        id: 'contacts',
        to: '/contacts',
        name: 'Контакты'
    }
]
